import React, { Component } from 'react';
import MapView from './MapView';
import crmServices from '../../wsclient/'
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import FilterView from '../offers/FilterView'
import {domainName, portal_config} from '../../../portal.config'
import t from '../../utils/translateUtil';
import ModalAlert from '../../components/ModalAlert';
import OfferDetail from '../offers/OfferDetail';
import { sortCartByProductName } from '../../utils/common';

const styles = theme => ({

});
class MapController extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoading: false,
            offers: null,
            merchants: null,
            currentLocation: null,
            centerRegion: null,
            showDirection: false,
            direction: null,
            isLoadedCurrentLocation: false,
            showMerchantNearYou: false,
            isSelectedFilter: false,
            filter_options: null,
            filter_options_org: null,
            zoomMap: 10,
            filterSelected: {
                industry: [{ id: "All", name: "All" }],
                industry_sector: [{ id: "All", name: "All" }],
                tag: [{ id: "All", name: "All" }],
                town_city: [{ id: "All", name: "All" }],
            },
            openFilter: false,
            showOfferDetai:false,
            offer: {},
        }
        this.onSelectMerchant = this.onSelectMerchant.bind(this)
        this.onShowMerchantsNearYou = this.onShowMerchantsNearYou.bind(this)
        this.onShowCurrentLocation = this.onShowCurrentLocation.bind(this)
        this.onOpenFilter = this.onOpenFilter.bind(this)
        this.onSelectFilter = this.onSelectFilter.bind(this)
        this.onFilter = this.onFilter.bind(this)
        this.onDirection = this.onDirection.bind(this)
        this.onCloseFilter = this.onCloseFilter.bind(this)
        this.onSearchPlace = this.onSearchPlace.bind(this)
        this.showMessage = this.showMessage.bind(this)
        this.resetMerchant = this.resetMerchant.bind(this)
        this.onShowOfferDetail = this.onShowOfferDetail.bind(this)
        this.onCloseOfferDetail = this.onCloseOfferDetail.bind(this)
    }
    componentWillMount() {
        if(portal_config[domainName].isOfferFilter){
            this.getIndustries();
            this.getIndustrySectors();
        }    
    }

    componentDidMount() {
        this.locationCheckTimer = setInterval(() => this.getLocation(), 500)
    }
    componentWillUnmount() {
        this.stopCheckingLocation();
    }
    stopCheckingLocation() {
        if (this.locationCheckTimer) {
            clearInterval(this.locationCheckTimer);
        }
        this.setState({ isLoadedCurrentLocation: true });
    }
    async getLocation() {
        if (this.state.currentLocation) {
            //console.log('LOCATION now is ', this.state.currentLocation)
            this.stopCheckingLocation();
            this.getStores({ ...this.state.currentLocation });
            this.getRegion(this.state.currentLocation);
            return;
        }

        await navigator.geolocation.getCurrentPosition((location) => {
            
            var currentLocation = {
                lat: location.coords.latitude,
                lon: location.coords.longitude,
            }
            //console.log(":AAAAAAAAAAAAAAAAAAAAAAAAA :",currentLocation);
            this.setState({ currentLocation: currentLocation });
        }, (err) => {
            console.log(' Offers getLocation err', err)
            this.setState({ showLoading: false });
            this.stopCheckingLocation();
            this.showMessage(true, t('enable_location_permissions'));
        }, {
            timeout: 5000,
            enableHighAccuracy: false
        });
        // console.log("AAAAAAAAAAAA getCurrentPosition currentLocation:", currentLocation);


    }

    getRegion(currentLocation) {
        if (currentLocation) {
            var region = {
                lat: currentLocation.lat,
                lng: currentLocation.lon,
                // latitudeDelta: 0.0922,
                // longitudeDelta: 0.0421,
            }
            this.setState({ centerRegion: region });
        }
    }
    async onShowCurrentLocation() {
        await navigator.geolocation.getCurrentPosition((location) => {
            // console.log("AAAAAAAAAAAA getCurrentPosition location:", location);
            var currentLocation = {
                lat: location.coords.latitude,
                lon: location.coords.longitude,
            }
            this.setState({ region: currentLocation });
        }, (err) => {
            console.log('getLocation err', err)
            this.setState({ showLoading: false });
            this.stopCheckingLocation();
        }, {
            timeout: 5000,
            enableHighAccuracy: false
        });

    }
    
    async getStores(params) {
        this.setState({ showLoading: true })
        try {
            params.within = 1000;
            // params.lat = 35.157322;
            // params.lon = 33.313751;
            var result = await crmServices.rewards.getLocations({ ...params });
            console.log("OfferMap AAAAAA result getStores:", result)
            //this.setState({ showLoading: false });
            if (result.code == 'OK') {
                var merchants = result.data && result.data.content ? result.data.content : [];
                // if (merchants.length > 0) {
                //     merchants = await this.addedImage(merchants);
                // }
                //console.log('getStores merchants=',merchants)
                if (merchants.length > 0)
                    this.setState({ merchants: merchants })
            }
        } catch (error) {
            console.log("load merchants exception:", error);
        }
        this.setState({ showLoading: false })
    }
    async addedImage(merchants) {
        var newMerchants = [];
        if (merchants.length > 0) {
            for (var i = 0; i < merchants.length; i++) {
                var merchant = merchants[i];
                var detailResult = await crmServices.rewards.getOrganisationDetail(merchant.id);
                //console.log("OfferMap AAAAAA result getOrganisationDetail:", detailResult)
                if (detailResult.code === 'OK') {
                    merchant.creatives = detailResult.data.creatives;
                    merchant.phone_number = this.getContactPhone(detailResult.data.contact_info);
                }
                newMerchants.push(merchant);
            }
        }
        return newMerchants;
    }
    getContactPhone(contact_info) {
        var phone_number = "";
        if (contact_info && contact_info.length > 0) {
            var phones = contact_info.filter(contact => {
                return contact.type === 'PHONE';
            })
            if (phones && phones.length > 0) {
                phone_number = phones[0].value;
            }
        }
        return phone_number;
    }
    async onLoadOffers(params) {
        try {
            var result = await crmServices.rewards.getOffers(params);
            //console.log('onLoadOffers=== ', result)
            if (result.code === 'OK') {
                var offers = result.data && result.data.content ? result.data.content : [];
                var newOffers = [];
                if (offers.length > 0) {
                    for (var i = 0; i < offers.length; i++) {
                        var offer_data = offers[i];
                        if(offer_data.performance_enabled){ 
                            var performanceData = await this.loadPerformance(offer_data.id);
                            offer_data.performance_data = performanceData;
                        }
                        newOffers.push(offer_data);
                    }
                }
                this.setState({ offers: newOffers });
            } else {

            }
        } catch (error) {
            console.log("on select merchant error:", error);
        }
    }
    async loadPerformance(offerId) {
        var performance_data = null;
        try {
            var result = await crmServices.rewards.getPerformanceOffer(offerId);
            if (result.code === 'OK') {
                performance_data = result.data;
            }
        } catch (error) {
            console.log("load offer exception:", error);
        }
        return performance_data;
    }
    async onSelectMerchant(merchant) {
        if (merchant.location && merchant.location.lat && merchant.location.lon) {
            this.setState({ showDirection: true, direction: merchant.location, centerRegion:merchant.location, zoomMap:12 });
        }
        this.setState({ showLoading: true });
        await this.onLoadOffers({ organisations: merchant.id });
        this.setState({ showLoading: false, showMerchantNearYou: false });
    }
    onShowMerchantsNearYou() {
        this.setState({ showMerchantNearYou: !this.state.showMerchantNearYou, offers: [] })
    }
   
    async getIndustries() {
        var filter_options = {...this.state.filter_options_org}
        var content = [];
        try {
            var result = await crmServices.config.getIndustries();
            //console.log('getIndustries result=', result)
            if (result.code == 'OK') {
                content = result.data && result.data.content ? result.data.content : [];
                filter_options.industries = content.sort(sortCartByProductName)
            }
        } catch (error) {
            console.log("get industries error:", error);
        }
        this.setState({filter_options_org: filter_options})
    }
    async getIndustrySectors() {
        
        var content = [];
        try {
            var result = await crmServices.config.getIndustrySectors();
            if (result.code == 'OK') {
                content = result.data && result.data.content ? result.data.content:[];
                var filter_options = {...this.state.filter_options_org}
                filter_options.industry_sectors = content.sort(sortCartByProductName)
                //console.log('getIndustrySectors filter_options=======',filter_options)
                this.setState({filter_options_org: filter_options})
            }
        } catch (error) {
            console.log("get industries error:", error);
        }

    }
    async getTags(filter_options) {
        var content = [];
        try {
            var params = {};
            params = this.getFilterParamByType("industry", "industry", params);
            params = this.getFilterParamByType("industry_sector", "industry_sector", params);
            if (params.industry || params.industry_sector) {
                var result = await crmServices.config.getOrganisationTags(params);
                if (result.code == 'OK') {
                    content = result.data && result.data.content ? result.data.content : [];
                }
            }
        } catch (error) {
            console.log("get industries error:", error);
        }
        var filter_options = this.state.filter_options ? this.state.filter_options : filter_options;
        console.log("AA filter_options:",filter_options);
        if(content.length > 0){ 
            filter_options.tags = [{ id: "All", name: "All" },...content.sort(sortCartByProductName)];
        }else{
            filter_options.tags = [{ id: "All", name: "All" }];
        }
        this.setState({ filter_options: filter_options });
    }
    async onSelectFilter(type, value) {
        var filter_options = this.state.filter_options;
        var filterSelected = this.state.filterSelected;
        var industry_sectors = this.state.filter_options_org.industry_sectors;
        if (value.id === 'All') {
            filterSelected[type] = [{ id: "All", name: "All" }];
            if (type === 'industry') {
                var filterSector = [];
                //if (industry_sectors && industry_sectors[0] && industry_sectors[0].id != 'All') {
                    industry_sectors = [{ id: "All", name: "All" }, ...industry_sectors];
                //}
                filterSector = industry_sectors
                filterSelected.industry_sector = [{ id: "All", name: "All" }];
                filterSelected.tag = [{ id: "All", name: "All" }];

                filter_options.industry_sectors = filterSector;
            }
        }
        else {
            if (filterSelected[type].length == 1 && filterSelected[type][0].id == 'All') {
                filterSelected[type].splice(0, 1);
            }
            let index = -1;
            for (var i = 0; i < filterSelected[type].length; i++) {
                if (filterSelected[type][i].id === value.id) {
                    index = i;
                    break;
                }
            }
            if (index >= 0) {
                filterSelected[type].splice(index, 1);
            }
            else {
                filterSelected[type].push(value);
            }
            if (type == 'industry') {
                var filterSector = [];
                var industrySelected = filterSelected.industry;
                industrySelected.forEach(industry => {
                    industry_sectors.forEach(sector => {
                        var related_industries = sector.related_industries;
                        var itemExist = related_industries.filter(i => {
                            return i.id == industry.id
                        })
                        if (itemExist && itemExist.length > 0) {
                            filterSector.push(sector);
                        }
                    })
                })
                filter_options.industry_sectors = [{ id: "All", name: "All" }, ...filterSector];
            }
            if (filterSelected[type].length == 0) {
                filterSelected[type] = [{ id: "All", name: "All" }]
                filterSector = [{ id: "All", name: "All" }, ...industry_sectors];

                filter_options.industry_sectors = filterSector;
            }
        }

        if (type == 'industry_sector') {
            filterSelected.tag = [{ id: "All", name: "All" }];
        }
        this.setState({ filter_options: filter_options, filterSelected: filterSelected, isSelectedFilter: true });
        this.getTags();
    }
    async onFilter() {
        this.setState({ showLoading: true });
        var params = { ...this.state.params }
        params = this.getFilterParamByType("industry", "industries", params);
        params = this.getFilterParamByType("industry_sector", "industry_sectors", params);
        params = this.getFilterParamByType("tag", "organisation_tags", params);
        params = this.getFilterParamByType("town_city", "town_cities", params);
        var currentLocation = this.state.currentLocation;
        await this.getStores({ ...params, ...currentLocation });
        this.resetMerchant();
        this.setState({ showLoading: false });
    }
    resetMerchant(){
        this.setState({ showDirection: false, direction: null,offers:[] });
    }
    getFilterParamByType(selectedType, paramType, params) {
        var filterSelected = this.state.filterSelected[selectedType];
        if (filterSelected.length > 0 && filterSelected[0].id != 'All') {
            params[paramType] = "";
            for (var i = 0; i < filterSelected.length; i++) {
                if (i == filterSelected.length - 1) {
                    params[paramType] = params[paramType] + filterSelected[i].id;
                } else {
                    params[paramType] = params[paramType] + filterSelected[i].id + ",";
                }
            }
        }
        else {
            delete params[paramType]
        }
        return params;
    }
    async onOpenFilter(){
        var filter_options = { ...this.state.filter_options_org };
        filter_options.industries = [{ id: "All", name: "All" }, ...filter_options.industries];
        filter_options.industry_sectors = [{ id: "All", name: "All" }, ...filter_options.industry_sectors];
        filter_options.tags=[{id: "All", name: "All"}]
        filter_options.town_city = [{id: "All", name: "All"}];
        var filter_options_org = filter_options;
        var industrySelected = this.state.filterSelected.industry;
        if (industrySelected.length > 0 && industrySelected[0].id != 'All') {
            var industry_sectors = filter_options.industry_sectors;
            var filterSector = [];
            industrySelected.forEach(industry => {
                industry_sectors.forEach(sector => {
                    var related_industries = sector.related_industries;
                    if (related_industries) {
                        var itemExist = related_industries.filter(i => {
                            return i.id == industry.id
                        })
                        if (itemExist && itemExist.length > 0) {
                            filterSector.push(sector);
                        }
                    }
                })
            })
            filter_options.industry_sectors = [{ id: "All", name: "All" }, ...filterSector];
        }
        this.setState({
            openFilter:true, 
            filter_options: filter_options, 
           // filter_options_org: filter_options,
            isSelectedFilter:false 
        });
        await this.getTags(filter_options);
    }
    onCloseFilter(){
        if(this.state.isSelectedFilter){
            this.onFilter();
        }
        this.setState({openFilter: false})
    }
    onDirection(direction) {
        console.log('direction:', direction);
        if (direction) {
            var url = 'https://www.google.com/maps/search/?api=1';
            if (direction.lat && direction.lon) {
                url = url + '&query=' + direction.lat + "," + direction.lon;
            }
            if (direction.googleplaceid) {
                url = url + '&query_place_id=' + direction.googleplaceid;
            }
            console.log("url:", url);
            window.open(url)
            //Linking.openURL(url);
            // openMap({ end: direction.lat + "," + direction.lon, provider: provider });
        }
    }
    onSearchPlace(detail) {
        console.log("onSearchPlace detail:",detail);
        //var geometry = detail.geometry.location;
       
        var location = {
            lat: detail.lat,
            lon: detail.lon,
        }
        this.setState({centerRegion: location, zoomMap: 12})

    }
    onShowOfferDetail(offer){
        this.setState({showOfferDetai: true, offer: offer})
        //console.log('onShowOfferDetail=== ')
    }
    onCloseOfferDetail(){
        this.setState({showOfferDetai: false})
    }
    showMessage(status, message) {
        this.setState({
            showLoading: false,
            message: {
                show: status,
                content: message ? message : null
            }
        })
    }
    render() {
        return (
            <div>
                <MapView
                    showLoading={this.state.showLoading}
                    offers={this.state.offers}
                    centerRegion={this.state.centerRegion}
                    zoomMap = {this.state.zoomMap}
                    onCloseMap={this.props.onCloseMap}
                    onSelectFilter={this.onSelectFilter}
                    isLoadedCurrentLocation={this.state.isLoadedCurrentLocation}
                    merchants={this.state.merchants}
                    onSelectMerchant={this.onSelectMerchant}
                    onOpenFilter={this.onOpenFilter}
                    showMerchantNearYou={this.state.showMerchantNearYou}
                    onShowCurrentLocation={this.onShowCurrentLocation}
                    onDirection={this.onDirection}
                    onShowOfferDetail = {this.onShowOfferDetail} 
                    onSearchPlace = {this.onSearchPlace}
                    resetMerchant = {this.resetMerchant}
                    />
                {this.state.openFilter&&<FilterView open={this.state.openFilter}
                    onClose={this.onCloseFilter}
                    filter_options={this.state.filter_options}
                    filterSelected={this.state.filterSelected}
                    onSelectFilter={this.onSelectFilter}
                    onApplyFilter = {this.onCloseFilter}/>}    
                {this.state.message && <ModalAlert
                    open={this.state.message.show}
                    onClose={this.showMessage}
                    message={this.state.message.content}
                />}
                {this.state.showOfferDetai&&<OfferDetail 
                    open={this.state.showOfferDetai}
                    offer = {this.state.offer}
                    handleDrawerToggle= {this.onCloseOfferDetail}/>}
            </div>
        );
    }
}

export default withStyles(styles)(withTranslation()(MapController));